import { render, staticRenderFns } from "./TableContextMenu.vue?vue&type=template&id=2c401bec"
import script from "./TableContextMenu.vue?vue&type=script&lang=js"
export * from "./TableContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports